import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';

function Contact() {

  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const form = useRef();

  const sendEmail = (e: any) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    if (name !== '' && email !== '' && message !== '') {
      var templateParams = {
        from_name: name, // Maps to "Your Name" from the form
        reply_to: email, // Maps to "Email / Phone" from the form
        message: message, // Maps to "Message" from the form
      };

      emailjs.send('service_2813xuz', 'template_i9s0h9p', templateParams, 'FYnKqtWz6z4mFc40_').then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Message sent successfully!');
          setName('');
          setEmail('');
          setMessage('');
        },
        (error) => {
          console.log('FAILED...', error);
          alert('Failed to send message. Please try again.');
        }
      );
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>Let's Connect! Ask me Anything.</p>
          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className="contact-form"
            onSubmit={sendEmail}
          >
            <div className="form-flex">
              {/* Name input */}
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input
                  type="text"
                  id="name"
                  placeholder="What's your name?"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={nameError ? 'input-error' : ''}
                />
                {nameError && <span className="error-message">Please enter your name</span>}
              </div>

              {/* Email input */}
              <div className="form-group">
                <label htmlFor="email">Email / Phone</label>
                <input
                  type="email"
                  id="email"
                  placeholder="How can I reach you?"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={emailError ? 'input-error' : ''}
                />
                {emailError && <span className="error-message">Please enter your email or phone number</span>}
              </div>
            </div>

            {/* Message textarea */}
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                placeholder="Send me any inquiries or questions"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className={messageError ? 'input-error' : ''}
                rows={5}
              />
              {messageError && <span className="error-message">Please enter the message</span>}
            </div>

            {/* Submit button */}
            <Button variant="contained" endIcon={<SendIcon />} type="submit">
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;
